/* WOD Armour redesign helpers (duplicate theme): sticky mobile ATC, cart cross-sell, chat shortcut */
(function () {
  'use strict';
  var WA_PHONE = '9109899276514'; // number used by the store's existing Shipway WhatsApp widget

  function openChat() {
    if (typeof window.cnvt_showDiv === 'function') { window.cnvt_showDiv(); return; }
    window.open('https://api.whatsapp.com/send/?phone=' + WA_PHONE, '_blank', 'noopener');
  }

  function initSticky(bar) {
    var sid = bar.getAttribute('data-section');
    var getAtc = function () { return document.getElementById('AddToCart-' + sid); };
    var priceBox = document.getElementById('price-' + sid);
    var btn = bar.querySelector('[data-wa-sticky-atc]');
    var priceEl = bar.querySelector('[data-wa-sticky-price]');
    var form = document.querySelector('#MainProduct-' + sid + ' product-form') || getAtc();
    if (!form || !btn) return;

    function syncPrice() {
      if (!priceBox || !priceEl) return;
      var p = priceBox.querySelector('.price');
      var el = p && p.classList.contains('price--on-sale') ? p.querySelector('.price-item--sale') : p && p.querySelector('.price-item--regular');
      if (el) priceEl.textContent = el.textContent.trim();
    }
    function syncBtn() {
      var atc = getAtc();
      if (!atc) return;
      btn.disabled = atc.disabled;
      var label = atc.querySelector('span');
      btn.textContent = atc.disabled ? (label ? label.textContent.trim() : 'Sold out') : (bar.getAttribute('data-atc-label') || 'Add to cart');
    }
    syncPrice(); syncBtn();
    if (priceBox && 'MutationObserver' in window) {
      new MutationObserver(function () { syncPrice(); syncBtn(); }).observe(priceBox, { childList: true, subtree: true, characterData: true });
    }
    var info = document.getElementById('MainProduct-' + sid);
    if (info && 'MutationObserver' in window) {
      new MutationObserver(syncBtn).observe(info, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }
    btn.addEventListener('click', function () {
      var atc = getAtc();
      if (atc && !atc.disabled) atc.click();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      }, { threshold: 0 }).observe(form);
    }
    bar.hidden = false;
  }

  function initUpsell() {
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-wa-upsell-add]');
      if (!b) return;
      ev.preventDefault();
      if (b.getAttribute('aria-busy') === 'true') return;
      b.setAttribute('aria-busy', 'true');
      var root = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
      fetch(root + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-variant-id')), quantity: 1 }] })
      }).then(function (r) { return r.json(); }).then(function () {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wa-upsell' });
        } else { window.location.href = (window.theme && window.theme.routes.cart_url) || '/cart'; }
      }).catch(function () { window.location.href = '/cart'; })
        .finally(function () { b.removeAttribute('aria-busy'); });
    });
  }

  function init() {
    document.querySelectorAll('[data-wa-sticky]').forEach(initSticky);
    initUpsell();
    document.addEventListener('click', function (ev) {
      var c = ev.target.closest && ev.target.closest('[data-wa-chat]');
      if (c) { ev.preventDefault(); openChat(); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
